module.exports = __webpack_public_path__ + "static/media/recalls.2ff64d8a.svg";